import { AnyAction } from 'redux';

import { storage } from 'common/storage';
import { NThunkAction } from 'state/types';

export enum BottomPinnedLegendActionTypes {
  Set = 'SET_PINNED_WIDGET_LEGEND',
}

export const PINNED_WIDGET_LEGEND_STORAGE_KEY = 'pinWidgetLegend';

export type BottomPinnedLegendAction = {
  type: BottomPinnedLegendActionTypes.Set;
  payload: boolean;
};

export function setBottomPinnedLegend(pinned: boolean): NThunkAction<void, AnyAction> {
  return (dispatch) => {
    storage.local.setItem(PINNED_WIDGET_LEGEND_STORAGE_KEY, pinned);

    dispatch({
      type: BottomPinnedLegendActionTypes.Set,
      payload: pinned,
    });
  };
}
